export default __webpack_public_path__ + "static/media/LJ3_ENG.5c309d05.mp4";